import { ExchangeIcon, DelayIcon } from 'assets/icons'
import ModalContainer from './ModalContainer'
import PrimaryButton from './primaryButton'
import Card from '../assets/images/card.png'
import RoundedIcon from './RoundedIcon'

const UnavailableCardModal = ({ isOpen, setIsOpen }) => (
  <ModalContainer
    className='text-black leading-[0.875rem]'
    noCloseButton
    isShown={isOpen}
    setModalFunction={setIsOpen}
  >
    <h3 className='text-center font-bold'>No pudimos solicitar tu tarjeta</h3>
    <DelayIcon className='mx-auto my-4' />
    <p className='text-xs text-center'>
      Por inconvenientes con nuestro proveedor, hay demoras para otorgar
      tarjetas.
    </p>
    <p className='text-xs mt-1 text-center'>
      Te avisaremos por mail cuando estén disponibles.
    </p>
    <p className='font-bold text-center text-xs my-4'>Mientras tanto...</p>
    <div className='flex gap-2 items-center'>
      <RoundedIcon
        className='h-6 w-6'
        icon={<img className='shrink-0 w-3 h-auto' src={Card} alt='' />}
      />
      <p className='font-medium text-2xs'>
        Aprovechá tu tarjeta Wayni virtual para hacer compras por internet.
      </p>
    </div>
    <div className='flex gap-2 mt-4 mb-8 items-center'>
      <RoundedIcon className='h-6 w-6' icon={<ExchangeIcon />} />
      <p className='font-medium text-2xs'>
        Utilizá tu CVU o Alias para enviar y recibir dinero a cuentas propias y
        de terceros.
      </p>
    </div>
    <PrimaryButton
      primaryButtonFunction={() => setIsOpen(false)}
      buttonText='¡Entendido!'
    />
  </ModalContainer>
)

export default UnavailableCardModal
